import styled from "styled-components";

export const StyledUl = styled.ul`
  list-style-type: disc;
  list-style-position: inside;
  padding-left: 0.5rem;
  padding: 0.5rem 0;
  border-radius: 0.375rem;

  & > li:last-of-type {
    margin-bottom: 0;
  }
`;

export const StyledLi = styled.li`
  margin-bottom: 0.5rem;
`;

export const GrayText = styled.span`
  color: #6b7280;
`;

export const Title = styled.h4`
  font-weight: 600;
  margin-top: 0.75rem;
  color: #374151;
`;

export const BlueLink = styled.button`
  color: #3b82f6;
  font-weight: 700;
  margin: 0.5rem 0;
  display: block;
  text-decoration: none;
  background-color: white;
  border: none;
  outline: none;
  text-decoration: underline;
`;

export const Card = styled.div`
  background-color: #f9fafb;
  padding: 0.75rem;
  border-radius: 0.375rem;
`;

export const Blockquote = styled.blockquote`
  border-left: 4px solid #3b82f6;
  background-color: #eff6ff;
  padding: 0.75rem;
  font-style: italic;
  color: #1e40af;
  border-radius: 0.375rem;
  margin: 0.5rem 0;
`;

export const SpaceY = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 0.75rem;
`;

export const SpaceYSm = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 0.25rem;
`;

export const Pl4 = styled.div`
  padding-left: 1rem;
`;

export const Pl5 = styled.ul`
  padding-left: 1.25rem;
`;

export const Ol = styled.ol`
  list-style-type: decimal;
  list-style-position: inside;
  padding-left: 1rem;
`;

export const BgGray = styled.div`
  background-color: #f9fafb;
  padding: 0.75rem;
  border-radius: 0.375rem;
`;

export const BgGraySm = styled.li`
  background-color: #f9fafb;
  padding: 0.75rem;
  border-radius: 0.375rem;
`;

export const Italic = styled.span`
  font-style: italic;
`;

export const FontBold = styled.strong`
  font-weight: bold;
`;

export const FontSemiBold = styled.span`
  font-weight: 600;
`;

export const FlexColGap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

export const BorderT = styled.p`
  border-top: 1px solid #e5e7eb;
  padding-top: 0.5rem;
`;

export const Pl20 = styled.p`
  padding-left: 20px;
  margin-top: 0.125rem;
`;

export const Pl20Li = styled.li`
  padding-left: 20px;
  margin-top: 0.125rem;
`;

export const TextBase = styled.span`
  font-size: 1rem;
`;

export const BgBlue = styled.div`
  background-color: #eff6ff;
  color: #1e40af;
  border-left: 4px solid #3b82f6;
  padding: 0.75rem;
  font-style: italic;
  border-radius: 0.375rem;
`;

export const Pl2 = styled.ul`
  padding-left: 0.5rem;
`;

export const Pl4Ul = styled.ul`
  padding-left: 1rem;
`;

export const Pl4Ol = styled.ol`
  padding-left: 1rem;
`;

export const Pl4Li = styled.li`
  padding-left: 1rem;
`;

export const Pl5Ul = styled.ul`
  padding-left: 1.25rem;
`;

export const Pl4P = styled.p`
  padding-left: 1rem;
`;

export const Pl4Div = styled.div`
  padding-left: 1rem;
`;

export const Pl4Span = styled.span`
  padding-left: 1rem;
`;
